import React from "react";
import { Form } from "react-bootstrap";
import UniChecks from "../../../../../@WUM/core/Elements/Form/Elements/Check";
import {InfoButton, IntlMessage, IntlMessageValue} from "../../../../../@WUM/core/Elements";
import {HeadlineHelp} from "../../../../../@WUM/core/Elements/InfoButton/Elements/HeadlineHelp";

interface WeekdaySelectorProps {
    value: string[] | null;
    onChange: (selected: string[]) => void;
    name?: string;
    disabled?: boolean;
}

const weekdays: { key: string; label: string }[] = [
    { key: "Mo.", label: "day.short.monday" },
    { key: "Di.", label: "day.short.tuesday" },
    { key: "Mi.", label: "day.short.wednesday" },
    { key: "Do.", label: "day.short.thursday" },
    { key: "Fr.", label: "day.short.friday" },
    { key: "Sa.", label: "day.short.saturday" },
    { key: "So.", label: "day.short.sunday" },
];

const WeekdaySelector: React.FC<WeekdaySelectorProps> = ({ value, onChange, name, disabled }) => {
    const toggleDay = (day: string) => {
        const base = value ?? [];
        const updated = base.includes(day)
            ? base.filter(d => d !== day)
            : [...base, day];
        onChange(updated);
    };

    return (
        <Form.Group className="mb-3 border rounded p-2">
            <HeadlineHelp Store={""} headType={'h6'} headlineText={'settings.workingDays.title'} descriptionText={"settings.workingDays.title.helper"} />

            <div className="d-flex align-items-center">
                {/* Linke Seitenbeschriftung */}
                <div className="me-2" style={{ minWidth: "7rem" }}>
                    <InfoButton.Wrapper>
                        {IntlMessage({ locale: "de", messageId: "settings.workingDays.label", Store: "" })}
                    </InfoButton.Wrapper>
                </div>

                {/* Wochentags-Spalten (Label-Reihe) */}
                <div className="d-flex flex-column">
                    <div className="d-flex justify-content-between">
                        {weekdays.map((day) => (
                            <div
                                key={`label-${day.key}`}
                                className="text-center"
                                style={{ width: "3rem", fontWeight: 500 }}
                            >
                                {IntlMessage({locale: 'de', messageId: day.label, Store: ''})}.
                            </div>
                        ))}
                    </div>

                    {/* Checkbox-Reihe */}
                    <div className="d-flex justify-content-between">
                        {weekdays.map((day) => (
                            <div key={`check-${day.key}`} style={{ width: "3rem" }} className="text-center">
                                <UniChecks
                                    type="checkbox"
                                    label=""
                                    value={day.key}
                                    checked={value?.includes(day.key)}
                                    onChange={() => toggleDay(day.key)}
                                    disabled={disabled}
                                    name={name}
                                    id={`${name}-${day.key}`}
                                    class="mb-0"
                                />
                            </div>
                        ))}

                    </div>


                </div>
                <InfoButton.Wrapper>
                    <InfoButton
                        text={IntlMessageValue('de', "settings.workingDays.label.helper", "")}
                        icon={'help'}
                    />
                </InfoButton.Wrapper>
            </div>
        </Form.Group>
    );
};

export default WeekdaySelector;
